import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { ApplicationState } from '../../models/application-state/application-state';
import { ApplicationService } from '../../../modules/application/shared/services/application/application.service';
import { GuardHelper } from '../../helpers/guard-helper/guard-helper';

@Injectable({
    providedIn: 'root',
})
export class CoordinationAuthGuard {
    constructor(
        private readonly router: Router,
        private readonly applicationService: ApplicationService,
        private readonly userStateService: UserStateService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const applicationId = route?.paramMap.get('id');

        if (!applicationId) {
            return GuardHelper.getErrorUrl(this.router);
        }

        return this.applicationService.getApplicationState(applicationId).pipe(
            switchMap((applicationState: ApplicationState) => {
                const userRole = this.userStateService.getRole();
                if (!userRole) {
                    return GuardHelper.getErrorUrl(this.router);
                }

                if (applicationState.isCoordinationAllowed) {
                    return of(true);
                }

                return GuardHelper.getErrorUrl(this.router);
            }),
            catchError(() => {
                return GuardHelper.getErrorUrl(this.router);
            }),
        );
    }
}
